import { useMutation } from '@tanstack/react-query';
import { updateMultipleOrdersItems } from '../../api/orderItems';

export const useUpdateMultipleOrderItems = () => {
  return useMutation({
    mutationFn: ({ token, ordersItem }) => updateMultipleOrdersItems(token, ordersItem),
  });
};
